<!-- Generated by IcoMoon.io -->
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
<title></title>
<g id="icomoon-ignore">
</g>
<path class="icon-color"  fill="#fff" d="M76.194 24.261l-17.18 85.963h349.874l-10.942 55.527h-350.094l-16.946 85.949h349.842l-19.509 98.032-141.006 46.711-122.2-46.711 8.364-42.521h-85.949l-20.448 103.176 202.113 77.352 233.003-77.352 76.884-386.126z"></path>
</svg>
